angular.module('inspinia').directive('baseSelect', () => {
  return {
    restrict: 'E',
    scope: {
      options: '@',
      type: '@',
      size: '@',
      ngDisabled: '=?',
      ngModel: '=',
      onChange: '&',
      placeholder: '@',
    },
    templateUrl: `/manage/src/view/directive/base_select.html?${new Date().getTime()}`,
    link: ($scope) => {
      if (!$scope.options) throw new Error('option not found.');
      $scope.isObject = false;
      $scope.ngDisabled || false;
      $scope.baseSelectOptions = JSON.parse($scope.options);

      $scope.baseSelectClasses = () => {
        let classes = 'anglrC-select';

        if ($scope.type === 'alert') {
          classes = classes + ' anglrC-select--alert';
        }
        let size = 's';
        if ($scope.size === 'small') {
          classes = classes + ` anglrC-select--${size}`;
        }

        return classes;
      };

      $scope.onChangeBaseSelect = (event) => {
        const setValue = () => $scope.onChange({ event });
        setTimeout(setValue, 100);
      };
    },
  };
});
